import { useState, useEffect, useRef } from 'react';
import GetUrls from 'ts/enums/Url'
import { Receipt } from 'ts/types'
import { http } from 'utils'
import toast from 'react-hot-toast'
import { Button, Input } from 'components/ui'
import { useTrader } from 'context/TraderTypeContext';
import useModalStore from 'store/modal'
import useAuthStore from 'store/auth'
import JsBarcode from 'jsbarcode';

interface StoreData {
  welcome: string;
  customerService: string;
  paidInFull: string;
  thankYou: string;
  imgUrl: string | null;
  gst: string;
}

const ReceiptAddPage = () => {
  const Url = GetUrls();
  const { traderId } = useTrader();
  const user = useAuthStore((state) => state.user);
  const [data, setData] = useState<StoreData | null>(null);
  const [isLoading, setLoading] = useState(false);
  const params = useModalStore((state) => state.params) as Receipt
  const barcodeRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, params.transactionNo, {
        format: "CODE128",
        lineColor: "#000",
        width: 1,
        height: 50,
        displayValue: true,
        fontSize: 10
      });
    }
  }, []);

  const fetchStoreData = async (): Promise<StoreData> => {
    try {
      const response = await http.get<StoreData>(Url.getReceiptFormat(traderId))
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const storeData = await fetchStoreData();
        setData(storeData);
      } catch (error) {
        toast.error('Failed to fetch store data.')
      } finally {
        setLoading(false);
      }
    };
    if (traderId || user?.traders.length === 0) {
      loadData();
    }
  }, [traderId]); 

  const handlePrint = () => {
    window.print();
  };
  
  return (
    <div className="px-8 py-6 rounded bg-gray-50 shadow-xl mt-4 mx-4 print-remove-style print-remove-container">
      <div className="flex">
        <div className="flex flex-col justify-between w-full print-hide mr-10">
          <div>
            <h1 className="text-lg font-bold">Trans. No: {params.transactionNo}</h1>
            <h1 className="text-sm text-gray-400">
              {new Date(params.transactionDate).toLocaleString('en-NZ', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
              }).replace(/\//g, '/').replace(',', ',')}
            </h1>
            <div className="shrink-0 bg-border h-025 w-full my-5" />
            <div className="mt-4">
              {/* TODO: Roger will create API to send email from CM */}
              {/* <form action="">
                <Input
                  id='email'
                  label="Send receipt copy"
                  placeholder="john.doe@example.com"
                />
                <Button
                  isLoading={isLoading}
                  className={`w-40 z-20 relative ${isLoading && 'cursor-default'}`}
                  disabled={isLoading}
                  type='submit'
                >
                  Send
                </Button>
              </form> */}
            </div>
            {/* <div className='shrink-0 bg-border h-025 w-full my-5'></div> */}
            <p className='font-semibold text-sm mb-1'>Print Receipt</p>
            <Button
              isLoading={isLoading}
              className={`w-40 z-20 relative ${isLoading && 'cursor-default'}`}
              disabled={isLoading}
              onClick={handlePrint}
            >
              Print
            </Button>
            <p className="text-xs mt-2 text-gray-400 w-96">Seeing the header and footer when printing? You can disable it by checking under your browser's Print Settings or Page Setup</p>
          </div>
        </div>
        {/* Receipt content */}
        <div id="receipt-content" className="relative w-full ">
          <div className="print-remove-style shadow-md flex text-center bg-white justify-center font-monospace items-center flex-col text-xs px-8 whitespace-pre-line">
            <img src={data?.imgUrl} alt="" className="max-h-8 my-5" />
            {params.receipt}
            <svg ref={barcodeRef}></svg>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReceiptAddPage
